import classNames from 'classnames';
import React, { FC } from 'react';

import { twMerge } from 'tailwind-merge';
import { ProductCardProps } from '../../types';
import CardHeadImage from './card-head-image';
import CardHeadLabel from './card-head-label';
import CardHeadSoldOut from './card-head-soldout';

const CardHeadHorizontal: FC<Partial<
  ProductCardProps & {
    imageNode?: React.ReactNode | (() => React.ReactNode);
    labelNode?: React.ReactNode | (() => React.ReactNode);
    imageContainerCls?: string;
    imageClassName?: string;
  }
>> = props => {
  return (
    <div
      className={twMerge('pt-0 relative w-[105px] h-[105px] flex-none', props?.imageContainerCls)}
      data-role="image-container">
      <CardHeadImage
        className={twMerge('rounded-400', props?.imageClassName)}
        imageProps={{ placeholderClassName: 'rounded-400' }}
        {...props}
      />

      <CardHeadLabel {...props} labelProps={{ showFeatureLabel: false }} />

      <CardHeadSoldOut
        {...props}
        cardType="horizontal"
        className="top-0 left-0 w-full h-full rounded-300 text-center"
      />

      {props.children}
    </div>
  );
};
export default CardHeadHorizontal;
